export default ({ children, type }) => {
    return (
        <div className={"popup " + ( type ? type : "" )}>
            { children }
        </div>
    )
}
